import {
  getMenuByRouter,
  createRoute
} from '@/libs/util'

import {
  getGroupDefaultProjects
} from "@/api/core";
import {
  getCoreList
} from "@/api/taskCore";
import {
  request
} from "@/api/all";

import routers from '@/router'

export default {
  state: {
    dynamicMenuLoaded: false,
    routes: [],
    loading: false,
    aside: {
      minimize: false,
      maximize: false,
      filemgr: false,
    },
    dialog: {
      show: false,
      fullScreen: false,
      persistent: false,
      title: 'Санамж',
      titleColorBg: '',
      titleColoTxt: '',
      content: '',
      contenctCls: '',
      txtClose: 'Хаах',
      txtOk: '',
      showOkBtn: false,
      yesOrNo: false,
      itemId: 0,
      itemObj: {},
      itemList: {
        title: '',
        list: [],
      },
    },
    snackBar: {
      show: false,
      showClose: false,
      txt: '',
    },

    groupDefaultObjects: [],
    groupDefaultProjects: [],

    pages: [],
    localCompose: {
      isShow: false,

      title: '',
      body: '',

      userIds: [],
      taskIds: [],
      attachIds: [],
      attachIdsForward: [],
      isDraft: false,
      draftId: 0
    },

  },
  getters: { 
    menuList: (state, getters, rootState) => getMenuByRouter(routers.options.routes, rootState.user.access),
    // getDynamicMenuLoaded: () => state.dynamicMenuLoaded,
    // getRoutes: () => state.routes,
    dynamicMenu: (state, getters, rootState) => getMenuByRouter(routers.options.routes, rootState.user.userInfo.access),
  },
  mutations: {
    setRoutes(state, routes) {
      state.routes = routes;
    },
    setDynamicMenuLoaded(state, isLoaded) {
      state.dynamicMenuLoaded = isLoaded;
    },
    setLoading(state, showLoader) {
      state.loading = showLoader;
    },
    setAside(state, obj) {
      state.aside.minimize = obj.minimize;
      state.aside.maximize = obj.maximize;
    },
    setDialog(state, obj) {
      state.dialog = obj;
    },
    setSnackbar(state, obj) {
      state.snackBar = obj;
    },

    setGroupDefaultProjects(state, data) {
      state.groupDefaultObjects = data.objects;
      state.groupDefaultProjects = data.projects;
    },
    setPages(state, pages) {
      state.pages = pages;
    },
    setLocalMailCompose(state, obj) {
      state.localCompose.isShow = obj.isShow;

      state.localCompose.title = obj.title == undefined ? '' : obj.title;
      state.localCompose.body = obj.body == undefined ? '' : obj.body;

      state.localCompose.attachIds = obj.attachIds == undefined ? [] : obj.attachIds;
      state.localCompose.userIds = obj.userIds == undefined ? [] : obj.userIds;
      state.localCompose.taskIds = obj.taskIds == undefined ? [] : obj.taskIds;
      state.localCompose.attachIdsForward = obj.attachIdsForward == undefined ? [] : obj.attachIdsForward;

      state.localCompose.isDraft = obj.isDraft == undefined ? false : obj.isDraft;
      state.localCompose.draftId = obj.draftId == undefined ? 0 : obj.draftId;
    },
  },
  actions: {
    handleDynamicMenuLoaded({ commit }, { v }) {
      commit("setDynamicMenuLoaded", v);
    },
    handleRoutes({
      commit,
      state
    }, {
      router
    }) {
      return new Promise((resolve, reject) => {
        try {
          if (!state.dynamicMenuLoaded) {
            commit('setDynamicMenuLoaded', true)
            request({
              api: {
                method: "GET",
                url: "Config/RouteList"
              },
            }).then(res => {
              if(res!=false)
              {
                commit('setRoutes', res.data.routes)
                
                res.data.routes.forEach(menu => {                  
                  // console.log(menu, res.data.access)
                  let x = createRoute(menu, res.data.access);
                  if(x!=null)
                    router.addRoutes([x]);
                });
                resolve(res.data.routes)
              }
              else{
                commit('setDynamicMenuLoaded', false);
                resolve([]);
              }
            }).catch(err => {
              reject(err)
            })
          } else {
            resolve(state.routes)
          }
        } catch (error) {
          reject(error)
        }
      })
    },

    handleLoading({
      commit
    }, {
      isLoading
    }) {
      commit("setLoading", isLoading);
    },
    handleAside({
      commit
    }, obj) {
      commit("setAside", obj);
    },
    handleDialog({
      commit
    }, {
      obj
    }) {
      commit("setDialog", obj);
    },
    handleSnackbar({
      commit
    }, {
      obj
    }) {
      commit("setSnackbar", obj);
    },

    handleGroupDefaultProjects({
      commit
    }, {
      store
    }) {
      return new Promise((resolve, reject) => {
        try {
          getGroupDefaultProjects({
            store: store
          }).then(res => {
            commit('setGroupDefaultProjects', res.data)
            resolve(res.data)
          }).catch(err => {
            reject(err)
          })
        } catch (error) {
          reject(error)
        }
      })
    },

    handlePages({
      commit
    }, {
      store
    }) {
      return new Promise((resolve, reject) => {
        try {
          getCoreList({
            data: {
              ot: 356,
              size: 200,
              skip: 0,
              model: {
                isPublic: true
              }
            },
            store: store
          }).then(res => {
            commit('setPages', res.data.tasks)
            resolve(res.data.tasks)
          }).catch(err => {
            reject(err)
          })
        } catch (error) {
          reject(error)
        }
      })
    },

    handleLocalMailCompose({
      commit
    }, obj) {
      return new Promise((resolve, reject) => {
        try {
          commit('setLocalMailCompose', obj)
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },
  },
};